export default "__VITE_ASSET__a378d5da__"